import { HiOutlineArrowNarrowRight } from "react-icons/hi";
import "./StickyActionMobile.scss";
export const StickyActionMobile = ({ onAction }: { onAction: () => void }) => {
    return (
        <div className="sticky_footer_mobile">
            <div className="custom_button_container" onClick={onAction}>
                {/* Sección Cian (Izquierda) */}
                <div className="button_section_cyan"></div>

                {/* Sección Naranja (Derecha) */}
                <div className="button_section_orange">
                    <span>SEPARAR VEHÍCULO</span>
                    <HiOutlineArrowNarrowRight />
                </div>
                <div className="image_container_sticky">
                    <img src="/assets/icons/rectangle-sticky-mobile.svg" height={"50%"} />
                </div>
            </div>
        </div>
    );
};
